











































































































































import { computed, defineComponent, ref } from "@vue/composition-api";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import Draggable from "vuedraggable";
import InputFieldGroup from "@/components/Organisms/InputFieldGroup/index.vue";
import InputField from "@/components/Organisms/InputField/index.vue";
import FieldAddButton from "@/components/Atoms/Forms/FieldAddButton/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHelp from "@/components/Atoms/OccHelp/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccSelectboxDate from "@/components/Atoms/OccSelectboxDate/index.vue";

import { JobEventResume } from "@/api/types";
import { JOB_EVENT_STORE_KEY } from "@/helpers/hooks/useJobEvent";
import { getRandomId } from "@/helpers/math-helper";
import { reorderArrayIndex } from "@/helpers/array-helper";
import {
  formConfig,
  ValidateKey,
  getResumeScrollKey
} from "@/helpers/jobEvent";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

export default defineComponent({
  components: {
    EmptyView,
    InputFieldGroup,
    InputField,
    FieldAddButton,
    OccHeading,
    OccButton,
    OccHelp,
    TextField,
    TextArea,
    OccSelectboxDate,
    Draggable
  },
  name: "ResumeForm",
  setup() {
    const {
      editingJobEvent,
      jobEventErrors,
      disabledEdit,
      setEditingJobEvent,
      getJobEventErrorMessage,
      resetResumeError
    } = useGlobalState(JOB_EVENT_STORE_KEY);

    const sortedResumes = computed(() =>
      [...(editingJobEvent.value?.resume_questions || [])].sort(
        (a, b) => a.position - b.position
      )
    );

    const hoveredItemId = ref<number>();

    const onClickAdd = () => {
      const additionalItem: JobEventResume = {
        id: getRandomId(),
        position: sortedResumes.value.length + 1,
        title: "",
        description: "",
        min_length: 0
      };

      const nextItems = [...sortedResumes.value, additionalItem];
      if (editingJobEvent.value) {
        setEditingJobEvent({
          ...editingJobEvent.value,
          resume_questions: nextItems
        });
      }
    };

    const onClickDelete = (itemId: number) => {
      const nextItems = sortedResumes.value
        .filter(item => {
          return item.id !== itemId;
        })
        .map((item, index) => {
          return {
            ...item,
            position: index + 1
          };
        });

      if (editingJobEvent.value) {
        resetResumeError(itemId);
        setEditingJobEvent({
          ...editingJobEvent.value,
          resume_questions: nextItems
        });
      }
    };

    type ChangeResumes = (
      itemId: number,
      updateCallBack: (targetItem: JobEventResume) => JobEventResume,
      validateKey: ValidateKey
    ) => void;

    const updatedResumes: ChangeResumes = (
      itemId,
      updateCallBack,
      validateKey
    ) => {
      const nextItems = sortedResumes.value.map(item => {
        if (item.id === itemId) {
          const nextItem = updateCallBack(item);
          return nextItem;
        }
        return item;
      });

      if (editingJobEvent.value) {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            resume_questions: nextItems
          },
          { key: validateKey, subKey: itemId }
        );
      }
    };

    const handleDragCompetitorEnd = ({
      oldIndex,
      newIndex
    }: {
      oldIndex: number;
      newIndex: number;
    }) => {
      const reorderedResumes = reorderArrayIndex(
        sortedResumes.value,
        oldIndex,
        newIndex
      ).map((resume, index) => ({
        ...resume,
        position: index + 1
      }));

      if (editingJobEvent.value) {
        setEditingJobEvent({
          ...editingJobEvent.value,
          resume_questions: reorderedResumes
        });
      }
    };

    return {
      formConfig,
      editingJobEvent,
      jobEventErrors,
      disabledEdit,
      setEditingJobEvent,
      getJobEventErrorMessage,
      resetResumeError,

      sortedResumes,
      hoveredItemId,
      updatedResumes,
      onClickAdd,
      onClickDelete,
      handleDragCompetitorEnd,
      getResumeScrollKey
    };
  }
});
